import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NewsletterResource } from 'app/models/NewsletterResource';
import { GdprCreateSubscribeService } from 'app/gdpr-create-subscribe/gdpr-create-subscribe.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'vbn-gdpr-create-subscribe',
  templateUrl: './gdpr-create-subscribe.component.html',
  styleUrls: ['./gdpr-create-subscribe.component.scss'],
  providers: [GdprCreateSubscribeService],

})
export class GdprCreateSubscribeComponent implements OnInit {

  newsletter: NewsletterResource;
  params: Promise<void>;

  gdprError: boolean = false;
  newsletterError: boolean = false;
  email: string;
  userEmail: string
  dispaySuccessMessage = false;
  lang = 'en';


  constructor(private gdprCreateSubscriberService: GdprCreateSubscribeService, private route: ActivatedRoute, private _route: Router) {
    this.newsletter = new NewsletterResource();
   }

  ngOnInit() {    
    this.params = this.route.params.forEach((params: Params) => {
      this.email = params['email'];
      this.userEmail = params['userEmail'];
      this.lang = params['lang'];
    });
  }


  agreeGDPR() {
    if (this.newsletter.keepMyPersonalData) {
      this.gdprError = false;
    }
    else {
      this.gdprError = true;
    }
  }

  agreeNewsletter() {
    if (this.newsletter.agreeToReceiveNewsletters) {
      this.newsletterError = false;
    }
    else {
      this.newsletterError = true;
    }
  }

  createSubscriber() {
    if (this.newsletter.keepMyPersonalData) {
      this.gdprError = false;

    }
    else {
      this.gdprError = true;
      return;
    }
    if (this.newsletter.agreeToReceiveNewsletters) {
      this.newsletterError = false;
    }
    else {
      this.newsletterError = true;
      return;
    }
    this.newsletter.email = this.email;

    this.newsletter.userEmail = this.userEmail;
    this.gdprCreateSubscriberService.postCreateUserGDPR('/admin/newsletter/activateNewsletter', this.newsletter)
      .subscribe(
      (response: NewsletterResource) => {
          this.dispaySuccessMessage = true;
        //this._route.navigate(['/home'])
      },
      error => {

      })

  }

}
